import Script from 'next/script';
import { PrizePage } from '@thisisdevelopment/heritage-core-library';
import styled from 'styled-components';
import theme from 'theme';
import Head from 'next/head';
import { H2, Paragraph } from '@thisisdevelopment/akzonobel-core';

const IFrame = styled.iframe`
  @media ${theme.mediaQuery.mobile} {
    min-height: 700px;
  }
  min-height: 550px;
`;

const TermsAndConditions = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;

  a {
    color: ${({ theme }) => theme.colors.brandGold};
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 600;
  }
`;

export default function TradePrizeDraw() {
  return (
    <>
      <Head>
        <title>Dulux Heritage Prize Draw</title>
      </Head>
      <PrizePage
        title="WIN! With Dulux Heritage"
        content={
          <>
            <H2>
              Enter to be in with a chance of winning Dulux Heritage paint for your next project!
            </H2>
            <Paragraph>
              Dulux Heritage provides the perfect blend of modern style and substance for any
              project. It has been skilfully crafted by professionals for professionals to deliver
              quality and genuine durability for everyday life - as well as beautiful aesthetics,
              with over 112 luxurious shades to choose from.
            </Paragraph>
            <H2>How to enter</H2>
            <Paragraph>
              Dulux is giving away 50litres of its Dulux Heritage paint to one lucky professional
              this December. Simply fill in the form below to be entered into the prize draw.
            </Paragraph>
            <Paragraph>
              Entries open at 12:01am on Monday 9th December and close at 11:59pm on Sunday 15th
              December.
            </Paragraph>
            <Paragraph>
              To stay in the loop with the latest product news, advice and competitions remember to
              tick the boxes to sign up for our newsletters.
            </Paragraph>
          </>
        }
        image={{
          url: 'https://datahose-cms.akzonobel.hosting/eukher/assets/1mrtdtue8zesgwsc',
          alt: 'Dulux Heritage Competition',
        }}
      >
        <Script
          id="munchkin"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
               (function() {
    var didInit = false;
    function initMunchkin() {
      if(didInit === false) {
        didInit = true;
        Munchkin.init('126-DNG-032', {"wsInfo":"j0hRdtjOKwEN"});
      }
    }
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = '//munchkin.marketo.net/munchkin.js';
    s.onreadystatechange = function() {
      if (this.readyState == 'complete' || this.readyState == 'loaded') {
        initMunchkin();
      }
    };
    s.onload = initMunchkin;
    document.getElementsByTagName('head')[0].appendChild(s);
  })();
        `,
          }}
        ></Script>
        <IFrame
          src="https://lp.akz.no/UKI-CF-2024-10-Heritage-Capture_Landinpage.html"
          width="100%"
          loading="lazy"
          style={{ border: 0, paddingTop: '40px' }}
          allowFullScreen
          aria-hidden="false"
          tabIndex={0}
        ></IFrame>
        <TermsAndConditions>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.duluxtradepaintexpert.co.uk/en/terms#DHdec24"
          >
            *Prize Draw Terms and Conditions
          </a>
        </TermsAndConditions>
      </PrizePage>
    </>
  );
}
